<div class="usage-container">
    <h1>Usage Metrics</h1>
    
    <mat-card class="date-range-card">
        <mat-card-header>
            <mat-card-title>Date Range</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="dateRangeForm" class="date-range-form">
                <mat-form-field>
                    <mat-label>From</mat-label>
                    <input matInput [owlDateTime]="dateFromPicker" [owlDateTimeTrigger]="dateFromPicker" formControlName="dateFrom" />
                    <owl-date-time #dateFromPicker></owl-date-time>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>To</mat-label>
                    <input matInput [owlDateTime]="dateToPicker" [owlDateTimeTrigger]="dateToPicker" formControlName="dateTo" />
                    <owl-date-time #dateToPicker></owl-date-time>
                </mat-form-field>
            </form>
        </mat-card-content>
    </mat-card>
    
    <div class="metrics-grid">
        <mat-card class="metric-card">
            <mat-card-header>
                <mat-card-title>SMS Messages Sent</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="metric-value">
                    <span class="value">{{ totalSmsSent$ | async }}</span>
                    <span class="label">Total SMS Sent</span>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card class="metric-card">
            <mat-card-header>
                <mat-card-title>SMS Messages Received</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="metric-value">
                    <span class="value">{{ totalSmsReceived$ | async }}</span>
                    <span class="label">Total SMS Received</span>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

